<!--
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-04-16 09:40:17
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-08-13 17:41:55
 * @FilePath: /goldenSalesMobile/src/views/GoodsDetail/index.vue
 * @Description:
-->
<template>
  <div class="page-container">
    <div v-if="isShowEmpty">
      <van-empty description="该产品已下架" image="error" />
    </div>
    <div v-else>
      <nav-bar title="产品详情" />
      <div class="goods-info">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item
            v-for="(item, index) in info.goodsBanners"
            :key="index"
          >
            <van-image :src="item.imgUrl" fit="cover" />
          </van-swipe-item>
        </van-swipe>
        <p class="goods-name">{{ info.Name }}</p>
        <div class="about-price">
          <span class="shelf-price"
            >￥<a>{{ info.CostPrice }}</a></span
          >
          <span class="shelf-originPrice">￥{{ info.MarketPrice }}</span>
          <span class="sales-num">已售：{{ info.Sales }}</span>
          <span class="stock-num">剩余：{{ info.Stock }}</span>
        </div>
        <div class="valid-time">
          <span>
            <svg-icon iconClass="valid" />
            有效期：{{ info.goodsValidTime }}
          </span>
          <a v-if="!info.IsAllowRefund">不支持退款</a>
        </div>
        <div class="sale-time" v-if="!isOnSale">
          <span>
            <svg-icon iconClass="fire" />
            销售日期：{{ info.SalesTime }}
          </span>
        </div>
        <ul class="vpns-info" v-if="info.Vpns.length > 0">
          <li v-for="(item, index) in info.Vpns" :key="index">
            <p class="store-name">
              <svg-icon iconClass="store" />
              {{ item.Name }}
            </p>
            <div class="address-tel">
              <span v-if="item.Address">
                <svg-icon iconClass="address" />
                {{ item.Address }}
              </span>
              <a v-if="item.Phone" :href="'tel:' + item.Phone">
                <svg-icon iconClass="tel" />
              </a>
            </div>
          </li>
        </ul>
      </div>
      <div class="goods-intro">
        <!-- // TODO 产品简介需要支持换行等格式化 -->
        <!-- <div class="short-intro"  v-if="info.shortIntros.length > 0">
          <h3>产品简介</h3>
          <p v-for="(intro, index) in info.shortIntros" :key="index">
            {{ intro }}
          </p>
        </div> -->
        <div class="short-intro" v-if="info.Introduction">
          <h3>产品简介</h3>
          <p>{{ info.Introduction }}</p>
        </div>
        <div class="detail-intro" v-if="info.introImgs.length > 0">
          <van-divider
            :style="{ fontSize: '13px', fontWeight: 600, color: '#CCCCCC' }"
          >
            详情介绍
          </van-divider>
          <div
            class="intro-img"
            v-for="(item, index) in info.introImgs"
            :key="index"
          >
            <van-image :src="item.imgUrl" fit="cover" />
          </div>
        </div>
      </div>
      <div class="fixed-btn">
        <van-button
          block
          :color="
            isOnSale
              ? 'linear-gradient(to right, #FA9B00, #FBCA39)'
              : 'linear-gradient(to right, #B5BBD0, #D7DDEA)'
          "
          @click="isOnSale && onPurchase()"
        >
          <p class="goods-price">
            {{ isOnSale ? "￥" : "" }}
            <span>{{ isOnSale ? info.CostPrice : "" }}</span>
            <a v-if="isOnSale && info.discountAmount > 0"
              >已省￥{{ info.discountAmount }}</a
            >
          </p>
          <p class="btn-text">{{ isOnSale ? "立即购买" : "暂不可售" }}</p>
        </van-button>
      </div>
    </div>
    <g-float-btn :itemWidth="50" :itemHeight="50">
      <template v-slot:icon>
        <svg-icon iconClass="other" />
      </template>
      <template v-slot:text>
        <span>我的订单</span>
      </template>
    </g-float-btn>
  </div>
</template>

<script>
import { getProductDetail } from "@/api/goods";
import { isDuringDate } from "@/utils/index";

export default {
  data() {
    return {
      productId: this.$route.params.id,
      info: {
        // shortIntros: [],
        introImgs: [],
        Vpns: [],
        // storeName: '五指养生（五道口店）',
        // goodsName: '专业足疗+背部按摩+单人脊柱脊背形态调理',
        // storeAddress: '北京市海淀区信心清华东路16号宝源办公楼A4幢（以海大厦）三层23号',
        // storeTel: '010-25886868',
        // goodsValidTime: '2020.02.20-2020.04.21',
        // isCanRefund: false,
        // goodsPrice: '36.00',
        // discountAmount: '10.5',
        // goodsBanners: [
        //   {
        //     imgUrl: require('../../assets/goods_img.png')
        //   }
        // ],
        // shortIntros: [
        //   '适用门店：所有门店',
        //   '项目时长：2小时',
        //   '套餐详情：按摩、推拿、护理'
        // ],
        // introImgs: [
        //   {
        //     imgUrl: require('../../assets/goods_img.png')
        //   }
        // ]
      },
      isShowEmpty: false,
      isOnSale: true,
      isWeChatClient: true,
    };
  },

  created() {
    // 缓存中获取当前的浏览器环境
    const storageBrowserType = this.$store.state.browserType;
    const browserType = storageBrowserType
      ? JSON.parse(storageBrowserType)
      : {};
    if (browserType.shell === "wechat") {
      this.isWeChatClient = true;
    } else {
      this.isWeChatClient = false;
    }
    // 获取分销员Id
    if (this.$route.query.distributorId) {
      localStorage.setItem("distributorId", this.$route.query.distributorId);
    }
    this.init();
  },

  methods: {
    init() {
      // 获取产品详情
      getProductDetail({ query: { id: this.productId } }).then((res) => {
        if (res.Pager.TotalCount > 0) {
          const data = res.Items[0];
          // 产品简介
          // data.shortIntros = []
          // 产品图片
          data.goodsBanners = [];
          data.introImgs = [];
          const imgArr = data.Claims;
          if (imgArr instanceof Array && imgArr.length > 0) {
            imgArr.map((item) => {
              if (item.TypeId === 0) {
                data.goodsImgUrl = `${item.CdnUrl}/${item.Value}`;
              }
              if (item.TypeId === 1) {
                data.goodsBanners.push({
                  imgUrl: `${item.CdnUrl}/${item.Value}`,
                });
              }
              if (item.TypeId === 2) {
                data.introImgs.push({ imgUrl: `${item.CdnUrl}/${item.Value}` });
              }
            });
          }
          // 产品有效期
          if (data.IsAbsoluteExpirationDate) {
            // 绝对日期
            data.goodsValidTime = `${data.ExpirationStartDate}至${data.ExpirationEndDate}`;
          } else {
            // 相对日期
            data.goodsValidTime = `自购买日起${data.ExpirationDays}天内有效`;
          }
          // 产品的销售日期
          this.isOnSale = isDuringDate(
            data.SaleStartDate || "1990-1-1",
            data.SaleEndDate || "2099-12-31"
          );
          data.SalesTime = `${data.SaleStartDate}至${data.SaleEndDate}`;
          // 产品优惠金额
          if (data.MarketPrice > data.CostPrice) {
            data.discountAmount = (data.MarketPrice - data.CostPrice).toFixed(
              2
            );
          }
          this.info = data;
        } else {
          this.isShowEmpty = true;
        }
      });
    },

    // 立即购买： 缓存当前商品信息，跳转提交订单页面
    onPurchase() {
      let data = this.info;
      sessionStorage.setItem(
        "goodsInfo",
        JSON.stringify({
          imgUrl: data.goodsImgUrl,
          id: data.Id,
          name: data.Name,
          price: data.CostPrice,
          validTime: data.goodsValidTime,
          number: 1,
          tenantId: data.TenantId,
        })
      );
      this.$router.push({
        name: "SubmitOrder",
      });
    },

    // 点击漂浮按钮
    onFloatBtnClicked() {
      if (this.isWeChatClient) {
        this.$router.push({
          name: "UsersOrder",
        });
      } else {
        if (localStorage.getItem("userToken")) {
          this.$router.push({
            name: "UsersOrder",
          });
        } else {
          sessionStorage.setItem("pageBeforeLogin", "checkMyOrder");
          this.$router.push({
            name: "Login",
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
img {
  object-fit: cover;
}
.page-container {
  width: 100%;
  min-height: 100vh;
  background: #f7f7f7;
  .goods-info {
    width: 100%;
    box-sizing: border-box;
    padding: 0 40px;
    background: $blockBgColor;
    margin-bottom: 10px;
    padding-top: 20px;

    > .my-swipe {
      width: 100%;
      height: 280px;
      margin-bottom: 20px;
      border-radius: 16px;
      overflow: hidden;

      &::v-deep .van-image {
        width: 100%;
        height: 100%;
      }
    }

    > .goods-name {
      @include multi-line-ellipsis(2);
      font-size: 34px;
      font-weight: 500;
      color: $secondFontColor;
      line-height: 48px;
      margin: 6px 0 20px;
    }

    .about-price {
      @include flex-box();
      margin-bottom: 30px;

      > .shelf-price {
        margin-right: 16px;
        line-height: 36px;
        font-size: 26px;
        color: $priceFontColor;
        font-weight: Semibold;

        > a {
          font-size: 40px;
        }
      }

      > .shelf-originPrice {
        margin-right: 144px;
        line-height: 28px;
        font-size: 26px;
        color: #999;
        text-decoration: line-through;
      }

      > .sales-num,
      .stock-num {
        line-height: 36px;
        font-size: 26px;
        color: $baseFontColor;
      }

      > .sales-num {
        margin-right: 40px;
      }
    }

    > .valid-time {
      @include flex-box(space-between);
      height: 100px;
      border-top: 2px solid #f7f7f7;

      > span {
        font-size: 28px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 40px;
      }

      > a {
        width: 130px;
        height: 40px;
        border-radius: 8px;
        border: 2px solid #cccccc;
        text-align: center;
        line-height: 40px;
        font-size: 20px;
        color: $baseFontColor;
      }
    }

    > .sale-time {
      > span {
        font-size: 28px;
        font-weight: 400;
        color: #cca567;
        line-height: 40px;
      }
    }

    .vpns-info {
      > li {
        border-top: 1px solid #f7f7f7;
        overflow: hidden;

        > .store-name {
          font-size: 28px;
          font-weight: Medium;
          color: $secondFontColor;
          line-height: 40px;
          margin: 28px auto 24px;
        }

        > .address-tel {
          @include flex-box(space-between);
          margin-bottom: 30px;

          > span {
            @include multi-line-ellipsis(2);
            flex: none;
            max-width: 546px;
            font-size: 28px;
            font-weight: 400;
            color: $secondFontColor;
            line-height: 40px;
          }

          > a {
            width: 34px;
            height: 32px;
          }
        }
      }
    }
  }

  .goods-intro {
    background: $blockBgColor;
    margin-bottom: 100px;

    .short-intro {
      box-sizing: border-box;
      padding: 0 40px;
      overflow: hidden;
      margin-bottom: 70px;

      > h3 {
        margin: 20px 0 16px;
        font-size: 36px;
        font-weight: 600;
        color: $secondFontColor;
        line-height: 50px;
      }

      > p {
        font-size: 28px;
        font-weight: 400;
        color: $baseFontColor;
        line-height: 40px;
      }
    }

    .detail-intro {
      > .intro-img {
        width: 100%;

        &::v-deep .van-image {
          width: 100%;
        }
      }
    }
  }

  .fixed-btn {
    height: 100px;

    &::v-deep .van-button {
      height: 100%;

      .van-button__text {
        @include flex-box(center, center);
        flex-direction: column;
        height: 100%;
      }
    }

    .goods-price {
      @include flex-box(center);
      font-size: 26px;
      font-weight: 600;
      color: $white;
      line-height: 36px;

      > span {
        font-size: 40px;
        margin-right: 10px;
      }

      > a {
        padding: 0 10px;
        font-size: 20px;
        font-weight: 400;
        color: $white;
        line-height: 28px;
        border-radius: 8px;
        border: 2px solid $white;
      }
    }

    .btn-text {
      font-size: 28px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 40px;
    }
  }

  .van-swipe-item,
  .van-image {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.fixed-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 2;
  width: 100%;

  .van-button {
    font-size: 18px;
    font-weight: 600;
  }
}
</style>
